/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseReasoningSummaryTextDeltaEvent = {
  type: "response.reasoning_summary_text.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  summaryIndex: number;
  delta: string;
};

/** @internal */
export const ResponseReasoningSummaryTextDeltaEvent$inboundSchema: z.ZodType<
  ResponseReasoningSummaryTextDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.reasoning_summary_text.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  summary_index: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "summary_index": "summaryIndex",
  });
});
/** @internal */
export type ResponseReasoningSummaryTextDeltaEvent$Outbound = {
  type: "response.reasoning_summary_text.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  summary_index: number;
  delta: string;
};

/** @internal */
export const ResponseReasoningSummaryTextDeltaEvent$outboundSchema: z.ZodType<
  ResponseReasoningSummaryTextDeltaEvent$Outbound,
  z.ZodTypeDef,
  ResponseReasoningSummaryTextDeltaEvent
> = z.object({
  type: z.literal("response.reasoning_summary_text.delta"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  summaryIndex: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    summaryIndex: "summary_index",
  });
});

export function responseReasoningSummaryTextDeltaEventToJSON(
  responseReasoningSummaryTextDeltaEvent:
    ResponseReasoningSummaryTextDeltaEvent,
): string {
  return JSON.stringify(
    ResponseReasoningSummaryTextDeltaEvent$outboundSchema.parse(
      responseReasoningSummaryTextDeltaEvent,
    ),
  );
}
export function responseReasoningSummaryTextDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseReasoningSummaryTextDeltaEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseReasoningSummaryTextDeltaEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseReasoningSummaryTextDeltaEvent' from JSON`,
  );
}
